// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5748f41d","732":"d945668a"}[chunkId] + ".chunk.js";
};